import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState({});

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        // Assuming `getSession` is a method to get the current session
        // You can modify this to use your authentication logic
        const session = localStorage.getItem('session');
        if (session) {
            const userData = session;
            // Extract Cognito session details
            const { accessToken, idToken, refreshToken } = JSON.parse(userData);
            const payload = idToken.payload;

            setUser({
                userGroups: payload['cognito:groups'],
                accessToken: accessToken.jwtToken,
                idToken: idToken,
                refreshToken: refreshToken,
                email: payload.email,
                name: payload.name,
                phoneNumber: payload.phone_number,
                username: payload['cognito:username'],
                emailVerified: payload.email_verified,
                phoneNumberVerified: payload.phone_number_verified,
                authTime: payload.auth_time,
                eventId: payload.event_id,
                issuer: payload.iss,
                audience: payload.aud,
                issuedAt: payload.iat,
                expiration: payload.exp,
                jwtId: payload.jti,
                originJwtId: payload.origin_jti,
                userId: payload.sub,
            });

            setIsLoggedIn(true);
        }
        else {
            setIsLoggedIn(false);
        }
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, isLoggedIn }}>
            {children}
        </UserContext.Provider>
    );
};


UserProvider.propTypes = {
    children: PropTypes.node.isRequired,
};